import { render, staticRenderFns } from "./order_over.vue?vue&type=template&id=58df10fe&scoped=true&"
import script from "./order_over.vue?vue&type=script&lang=js&"
export * from "./order_over.vue?vue&type=script&lang=js&"
import style0 from "./order_over.vue?vue&type=style&index=0&id=58df10fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df10fe",
  null
  
)

export default component.exports